import React, { useState, useEffect } from 'react';
import { Image, RichText, Text, getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import VideoSlide from './VideoSlide';
import TextSlide from './TextSlide';

const ExpertsOpinion = ({ fields }) => {
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    var swiperCusTestimonials = new Swiper('.hear-experts-have-to-say-swiper', {
      spaceBetween: 0,
      centeredSlides: !1,
      autoplay: !1,
      slidesPerView: 4,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 0,
          slidesOffsetBefore: 0,
          centeredSlides: !1,
        },
        769: {
          slidesPerView: 2.3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: !0,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var element = document.querySelector('.hear-experts-have-to-say-swiper');
    if (typeof element !== 'undefined' && element !== null) {
      var swiperContainer = document.querySelector('.hear-experts-have-to-say-swiper');
      var windowWidth = window.innerWidth;
      var slideCount = swiperCusTestimonials.slides.length;
      if (slideCount <= 4) {
        swiperContainer.classList.add('disabled-swiper');
        if (slideCount === 3 && windowWidth <= 1024) {
          swiperContainer.classList.remove('disabled-swiper');
        }
        if (slideCount === 2 && windowWidth < 767) {
          swiperContainer.classList.remove('disabled-swiper');
        }
      }
    }
  }, []);

  return (
    <>
      <section className="hear-what-the-experts-section lazy-content" id="experts_testimonials">
        <div className="section-inner">
          <div className="section-heading-row">
            <div
              className="hear-what-the-expert-heading span-1-anm"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <h2 className="section-heading heading-flex ">
                <RichText field={fields?.heading} tag="span" editable={true} />
              </h2>
              <p className="section-para">
                <Text field={fields?.subheading} editable={true} />
              </p>
            </div>
          </div>
          <div
            className="hear-what-the-experts-slider-row span-1-anm"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className="slider-inner">
              <div className="swiper hear-experts-have-to-say-swiper">
                <div className="swiper-pagination csr_pagination"></div>
                <div className="csr_swiper_arrows_wrapper csr_swiper_arrows">
                  <div className="swiper-button-prev">
                    <span className="circle_arrow_red">
                      <em className="right_arrow"></em>
                    </span>
                  </div>
                  <div className="swiper-button-next">
                    <span className="circle_arrow_red">
                      <em className="right_arrow"></em>
                    </span>
                  </div>
                </div>
                <div className="swiper-wrapper">
                  {fields?.carouselItems?.map((y, index) => {
                    let x = y.fields;
                    if (x.YoutubeID?.value?.length > 0) {
                      return (
                        <VideoSlide
                          key={index}
                          EntryDate={x.EntryDate?.value}
                          AuthorTitle={x.AuthorTitle?.value}
                          AuthorName={x.AuthorName?.value}
                          YoutubeID={x.YoutubeID?.value}
                          PosterImage={x.PosterImage?.value?.src}
                          AuthorImage={x.AuthorImage?.value?.src}
                          SectionTItle={fields?.heading?.value}
                        ></VideoSlide>
                      );
                    } else if (x.Heading?.value?.length > 0) {
                      return (
                        <TextSlide
                          key={index}
                          Background={x.Background?.value}
                          AuthorTitle={x.AuthorTitle?.value}
                          AuthorName={x.AuthorName?.value}
                          Heading={x.Heading?.value}
                          Address={x.Address?.value}
                          AuthorImage={x.AuthorImage?.value?.src}
                        ></TextSlide>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {}
      <div
        className="modal experts-section-modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-dilog-vid">
                <div className="vid-dilog-inner">
                  <iframe
                    width="560"
                    id="video-ex"
                    height="315"
                    src={videoSrc}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpertsOpinion;
